import React, { useState } from 'react';
import { Link } from 'react-router-dom'
import "../index.css"
import { FaBars } from "react-icons/fa";
import { ImCross } from "react-icons/im";
import { navItems } from '../Components/DropdownNavItems'
import MainDropDown from '../DropDown/MainDropDown';
import AdmissionDropDown from '../DropDown/AdmissionDropDown';
import AcadamicDropdown from '../DropDown/AcadamicDropdown';
import ServicesDropdown from '../DropDown/ServicesDropdown';
import FeedbackDropdown from '../DropDown/FeedbackDropdown';
import QuicklinksDropdown from '../DropDown/QuicklinksDropdown';


const DropdownNav = () => {
    const [mobile, setMobile] = useState(false)
    const [dropDown, setDropDown] = useState(false)
    const [admissionDropdown, setAdmissionDropdown] = useState(false)
    const [acadamicDropdown, setAcadamicDropdown] = useState(false)
    const [servicesDropdown, setServicesDropdown] = useState(false)
    const [feedbackDropdown, setFeedbackDropdown] = useState(false)
    const [quicklinksDropdown, setQuicklinksDropdown] = useState(false)
    return (
        <div>
            <nav className='navbar'>
                <div></div>
                <ul className={mobile ? "navlinks-mobile" : 'navlinks'} onClick={() => setMobile(false)}>
                    {
                        navItems.map(item => {
                            if (item.title === "About Us ⮟") {
                                return (
                                    <li key={item.id} className={item.cName} onMouseEnter={() => setDropDown(true)} onMouseLeave={() => setDropDown(false)}>
                                        <Link to={item.path} >{item.title}</Link>
                                        {dropDown && <MainDropDown />}
                                    </li>
                                )
                            }
                            if (item.title === "Admission ⮟") {
                                return (
                                    <li key={item.id} className={item.cName} onMouseEnter={() => setAdmissionDropdown(true)} onMouseLeave={() => setAdmissionDropdown(false)}>
                                        <Link to={item.path} >{item.title}</Link>
                                        {admissionDropdown && <AdmissionDropDown />}
                                    </li>
                                )
                            }
                            if (item.title === "Acadamic ⮟") {
                                return (
                                    <li key={item.id} className={item.cName} onMouseEnter={() => setAcadamicDropdown(true)} onMouseLeave={() => setAcadamicDropdown(false)}>
                                        <Link to={item.path} >{item.title}</Link>
                                        {acadamicDropdown && <AcadamicDropdown /> }
                                    </li>
                                )
                            }
                            if (item.title === "Services ⮟") {
                                return (
                                    <li key={item.id} className={item.cName} onMouseEnter={() => setServicesDropdown(true)} onMouseLeave={() => setServicesDropdown(false)}>
                                        <Link to={item.path} >{item.title}</Link>
                                        {servicesDropdown && <ServicesDropdown /> }
                                    </li>
                                )
                            }
                            if (item.title === "Feedback ⮟") {
                                return (
                                    <li key={item.id} className={item.cName} onMouseEnter={() => setFeedbackDropdown(true)} onMouseLeave={() => setFeedbackDropdown(false)}>
                                        <Link to={item.path} >{item.title}</Link>
                                        {feedbackDropdown && <FeedbackDropdown /> }
                                    </li>
                                )
                            }
                            if (item.title === "QuickLinks ⮟") {
                                return (
                                    <li key={item.id} className={item.cName} onMouseEnter={() => setQuicklinksDropdown(true)} onMouseLeave={() => setQuicklinksDropdown(false)}>
                                        <Link to={item.path} >{item.title}</Link>
                                        {quicklinksDropdown && <QuicklinksDropdown /> }
                                    </li>
                                )
                            }
                            return (
                                <li key={item.id} className={item.cName}>
                                    <Link to={item.path}>{item.title}</Link>
                                </li>
                            )

                        })
                    }
                </ul>

                {/* <button className='mobile-Menu-Icon' onClick={() => setMobile(!mobile)}>
                    {
                        mobile ? <ImCross /> : <FaBars />
                    }

                </button> */}


            </nav>
        </div>
    );
}

export default DropdownNav;
